"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoOptionResultsComp = void 0;
var react_1 = __importDefault(require("react"));
var Typo2_1 = require("../../../Typo2");
var NoOptionResultsComp = function (_a) {
    var S = _a.S;
    var TYPO_COMP = S ? Typo2_1.UI_BODY_SM_DF : Typo2_1.UI_BODY_DF;
    return (react_1.default.createElement("div", { style: { padding: '1.2rem 0.8rem' } },
        react_1.default.createElement(TYPO_COMP, { style: { fontStyle: "italic" } }, "No Results!")));
};
exports.NoOptionResultsComp = NoOptionResultsComp;
